var _rect, _rect2, _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconcardchip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32,
    rx: 4,
    fill: "url(#paint0_radial_48_4897)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_48_4897",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32,
    rx: 4,
    fill: "url(#paint1_radial_48_4897)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_48_4897)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9997 0.320312L18.6664 8.68298C18.6664 8.68298 20.7997 16.0003 18.6664 22.2723L23.9997 31.6803L29.333 22.2723C29.333 22.2723 27.1997 17.0456 29.333 8.68298C29.333 8.68298 23.9997 0.320312 23.9997 0.320312Z",
    stroke: "#C7C7B6",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.06458H18.6667",
    stroke: "#C7C7B6",
    strokeWidth: 1.89089,
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7991 9.06458H47.9991",
    stroke: "#C7C7B6",
    strokeWidth: 1.89089,
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.8654H18.6667",
    stroke: "#C7C7B6",
    strokeWidth: 1.89089,
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7991 21.8654H47.9991",
    stroke: "#C7C7B6",
    strokeWidth: 1.89089,
    strokeLinejoin: "bevel"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_48_4897",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.5641 11.6565) rotate(141.302) scale(32.5381 32.2914)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDCDA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_48_4897",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.5641 11.6565) rotate(141.302) scale(32.5381 32.2914)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDCDA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconcardchip);
export default __webpack_public_path__ + "static/media/icon.card.chip.c3614a354775ed2fff582dc4efbdcd92.svg";
export { ForwardRef as ReactComponent };